
<template>
    <div class="splash" id="VerifyEmail" >
        <div class="admin-page-content">
            <!-- <div class="splash-logo">
                <img src="/static/images/splash-logo1.png" alt="FleetPro Application">
            </div> -->

            <section>
                <div class="fa-login-container" style="overflow-y: auto; height: 900px;">
                </div>
                <!-- <button id="checkemailbtn" class="btn btn-primary" style="margin-left:5px;" type="submit" v-on:click="cpiProofReviewStatus()">Click To Approve</button> -->

            </section>

        </div>
    </div>

</template>
<script>

    import EventBus from './event-bus.js';

    export default {
        name: "VerifyEmail",
        data: () => ({

        }),
        created: function() {

        },
        mounted: function() {

            var self = this;

            //hide header
            EventBus.$emit('logged-in', false,"","","");

            $(document).ready(function(){
                $("#login").height($(window).height() + 'px');
            });
            $(window).resize(function(){
                $("#login").height($(window).height() + 'px');
            });
            $("input").keypress(function(e) {
                if (e.keyCode === 13) {
                    if (e.target.id == 'email') {
                        self.cpiProofReviewStatus();
                    }
                }
            });

                var self = this;
                var encodeURL = self.$route.query.unique;

                var decodeURL = atob(encodeURL);
                var split = decodeURL.split("&");
                var value = split[2].split("=");

                var uniqueNo = split[0];
                var cpi_proof_review_id = value[1];

                self.getContractAssetData(cpi_proof_review_id);

        },
        methods: {

            cpiProofReviewStatus: function () {

                var self = this;
                var encodeURL = self.$route.query.unique;

                var decodeURL = atob(encodeURL);
                var split = decodeURL.split("&");
                var value = split[1].split("=");

                var uniqueNo = split[0];
                var customer_id = value[1];

                if (uniqueNo != undefined) {

                    $.ajax({
                        url: process.env.ROOT_API + "/cpiproofreview-change-status",
                        type: "GET",
                        crossDomain: true,
                        data: {
                            uniqueNo: uniqueNo,
                            customer_id: customer_id,
                        },
                        dataType: 'json',
                        success: function (data) {
                            if (data.status == "success") {
                                // self.$router.push("/dashboard");
                                alert("Successfully CPI Rate Approved!");
                            } else {
                                alert("CPI Rate has been already Approved!");
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.Registerbtn = "Register";
                            if (jqXHR.status == 0) {
                                self.registerError = "Remote server cannot be reached";
                            }
                        }
                    });
                } else {

                    alert("Customer !");
                }
            },

            getContractAssetData(cpi_proof_review_id) {

                var self = this;
                // alert(cpi_proof_review_id);return false;

                if (cpi_proof_review_id != undefined) {

                    $.ajax({
                        url: process.env.ROOT_API + "/get-customer-contract-data",
                        type: "GET",
                        crossDomain: true,
                        data: {
                            cpi_proof_review_id: cpi_proof_review_id,
                            flag: "cpi_adjustment",
                        },
                        //dataType: 'json',
                        success: function (data) {

                        $(".fa-login-container").html(data);
                        $(".fa-login-container .calculation-table").append('<button id="checkemailbtn" class="btn btn-primary" style="margin-left:5px;margin-top:20px;" type="submit" v-on:click="cpiProofReviewStatus()">Click To Approve</button>');

                        },
                        error: function (jqXHR, exception) {
                            self.Registerbtn = "Register";
                            if (jqXHR.status == 0) {
                                self.registerError = "Remote server cannot be reached";
                            }
                        }
                    });
                }

            },

            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/CPIProofReviewStatusChange.vue